const FETCH_COMMODITIES= "FETCH_COMMODITIES";
const FETCH_COMMODITIES_SUCCESS = "FETCH_COMMODITIES_SUCCESS";
const FETCH_COMMODITIES_ERROR = "FETCH_COMMODITIES_ERROR";
const UPDATE_COMMODITIES = "UPDATE_COMMODITIES";
const UPDATE_COMMODITIES_SUCCESS = "UPDATE_COMMODITIES_SUCCESS";
const UPDATE_COMMODITIES_ERROR = "UPDATE_COMMODITIES_ERROR";
const DELETE_COMMODITIES = "DELETE_COMMODITIES";
const DELETE_COMMODITIES_SUCCESS = "DELETE_COMMODITIES_SUCCESS";
const DELETE_COMMODITIES_ERROR = "DELETE_COMMODITIES_ERROR";
const CREATE_COMMODITIES = "CREATE_COMMODITIES";
const CREATE_COMMODITIES_SUCCESS = "CREATE_COMMODITIES_SUCCESS";
const CREATE_COMMODITIES_ERROR = "CREATE_COMMODITIES_ERROR";
const IS_ADDING_UPDATE = "IS_ADDING_UPDATE";

export {
  FETCH_COMMODITIES,
  FETCH_COMMODITIES_SUCCESS,
  FETCH_COMMODITIES_ERROR,
  UPDATE_COMMODITIES,
  UPDATE_COMMODITIES_SUCCESS,
  UPDATE_COMMODITIES_ERROR,
  DELETE_COMMODITIES,
  DELETE_COMMODITIES_SUCCESS,
  DELETE_COMMODITIES_ERROR,
  CREATE_COMMODITIES,
  CREATE_COMMODITIES_SUCCESS,
  CREATE_COMMODITIES_ERROR,
  IS_ADDING_UPDATE,
};
